<template>
  <div class="text-right" style="padding-top:0.34rem">
    <div style="margin-bottom:0.5rem" v-for="(item, index) in $t('guild.guild_certification10')" :key="index">
      <div class="title">{{item.title}}</div>
      <div class="contentbox" v-for="(item, indexs) in item.value" :key="indexs" :style="indexs==0?'padding:0':''">
        <div class="dian"></div>
        <div class="content">
          {{item}}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "App",
  components: {
    // HelloWorld
  },
  data() {
    return {
      userInfo: []
    };
  },
  created() {
    document.getElementsByTagName("html")[0].style.margin = "0 16px 0 16px";
  },
  mounted() {
    this.$completes.complete("getUserInfo");
    window.getUserInfo = this.getUserInfo
    window['getUserInfo'] = (data) => {
      this.getUserInfo(data);
    }
  },
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      let langs = this.userInfo.lang.substring(0, 2)
      let lang = this.userInfo.lang
      if (langs == 'zh') {
        if (lang == 'zh_TW' || lang == 'zh_HK') {
          this.$i18n.locale = 'tc'
        }
        else{
          this.$i18n.locale = 'zh'
        }
      }
      else if (langs == 'en') {
        this.$i18n.locale = 'en'
      }
      else if (langs == 'ar') {
        this.$i18n.locale = 'ar'
      }
       else if (langs == "fr") {
        this.$i18n.locale = "fr"
      } else if (langs == "id") {
        this.$i18n.locale = "id"
      } else if (langs == "ms") {
        this.$i18n.locale = "ms"
      } 
      else {
        this.$i18n.locale = 'en'
      }
      document.title = this.$t('guild.guild_certification09')
      document.querySelector('html').setAttribute('lang', this.$i18n.locale);
    },

  },

};

</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html[lang="ar"] .text-right {
  /* direction: rtl; */
}

html[lang="ar"] .dian {
  margin: 0.12rem 0 0 0.135rem;
}

html[lang="ar"] .contentbox {
  text-align: right;
  direction: rtl;
}

html[lang="ar"] .title {
  direction: rtl;
}

body {
  opacity: 0.85;
}

.bg {
  background: #000000;
}

.box {
  position: relative;
  margin-top: 88px;
}

.title {
  font-size: 0.256rem;
  font-family: Mediums;
  color: #000000;
  padding-bottom: 0.247rem;
}

.contentbox {
  display: flex;
  padding: 0.299rem 0 0 0;
}

.content {
  font-size: 0.239rem;
  font-family: Regulars;
  font-weight: 400;
  color: #000000;
}

.dian {
  width: 0.07rem;
  height: 0.07rem;
  background: #000000;
  border-radius: 50%;
  margin-right: 0.07rem;
  min-width: 0.07rem;
  min-height: 0.07rem;
  margin: 0.12rem 0.135rem 0 0;
}
</style>